import { render, staticRenderFns } from "./outpatientguide.vue?vue&type=template&id=37f0cb12&scoped=true"
import script from "./outpatientguide.vue?vue&type=script&lang=js"
export * from "./outpatientguide.vue?vue&type=script&lang=js"
import style0 from "./outpatientguide.vue?vue&type=style&index=0&id=37f0cb12&prod&lang=less&scoped=true"
import style1 from "./outpatientguide.vue?vue&type=style&index=1&id=37f0cb12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0cb12",
  null
  
)

export default component.exports